import { Box, Collapse, IconButton, Typography } from "@mui/material"
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined, WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import { SpecialPricingBlock } from "./SpecialPricingBlock"

import type { PriceChangeItem } from "@/graphql/codegen/graphql"
import type { ExistingSpecialRow } from "@/screens/Sales/hooks/useGetCustomerPricing"

interface ExistingSpecialsAlertProps {
  productId: number
  specials: ExistingSpecialRow[]
  onSelectSpecial: (special: PriceChangeItem) => void
}

export const ExistingSpecialsAlert: FC<ExistingSpecialsAlertProps> = ({ productId, specials, onSelectSpecial }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  if (!specials.length) return null

  const handleExpandToggle = () => setIsExpanded((prev) => !prev)

  return (
    <Box className='flex flex-col gap-2 rounded border border-tertiary-orange-300 bg-tertiary-orange-100 p-3'>
      <Box className='flex items-center justify-between gap-2'>
        <Box className='flex items-center gap-2'>
          <WarningOutlined className='text-tertiary-orange-700' />
          <Typography className='text-sm text-[#663C00]'>
            Special pricing exists for this customer&apos;s location(s).
          </Typography>
        </Box>
        <IconButton
          size='small'
          onClick={handleExpandToggle}
          aria-label={isExpanded ? "Collapse special pricing" : "Expand special pricing"}
          data-testid={`sales.product-pricing-form.existing-specials-toggle-${productId}`}
        >
          {isExpanded ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
        </IconButton>
      </Box>
      <Collapse in={isExpanded} unmountOnExit>
        <Box className='flex flex-col gap-2 pt-2'>
          {specials.map((row, index) => (
            <SpecialPricingBlock
              key={row.item.id}
              row={row}
              productId={productId}
              index={index}
              onAdd={onSelectSpecial}
            />
          ))}
        </Box>
      </Collapse>
    </Box>
  )
}
